import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { translate } from '@jsverse/transloco';
import { ICreateWearingPartRequest, ICreateWearingPartResponse, IExportWearingParts, IGetWearingPartResponse, IUpdateWearingPartRequest, IUpdateWearingPartResponse, IWearingPartRevision } from '../models/wearing-part';

@Injectable({
  providedIn: 'root'
})
export class WearingPartService {

    constructor(private http: HttpClient) { }

    createWearingPart(request: ICreateWearingPartRequest) {
        return this.http.post<ICreateWearingPartResponse>(
            `${environment.baseUrl}/v1/wearingParts/createWearingPart`,
            request
        )
    }

    getWearingPart(id: string){
        return this.http.get<IGetWearingPartResponse>(
          `${environment.baseUrl}/v1/wearingParts/getWearingPart/${id}`
        )
    }

    getWearingPartsByDevice(id: string){
        return this.http.get<IWearingPartRevision[]>(
            `${environment.baseUrl}/v1/wearingParts/getWearingPartsByDevice/${id}`,
        )
    }

    getWearingPartsByRevision(id: string){
        return this.http.get<IPagedResults<IGetWearingPartResponse[]>>(
            `${environment.baseUrl}/v1/wearingParts/getWearingPartsByRevision/${id}`,
        )
    }

    updateWearingPart(request: IUpdateWearingPartRequest){
        return this.http.put<IUpdateWearingPartResponse>(
            `${environment.baseUrl}/v1/wearingParts/updateWearingPart/${request.id}`,
            request
        )
    }

    deleteWearingPart(id :string){
        return this.http.delete(
            `${environment.baseUrl}/v1/wearingParts/deleteWearingPart/${id}`
        )
    }

    exportWearingPartsByDevice(id: string) {
        return this.http.get(`${environment.baseUrl}/v1/wearingParts/exportWearingPartsByDevice/${id}`, {
            responseType: 'blob' // Expecting a binary response (Blob)
        }).subscribe(
            (response: Blob) => {
                // Create a download link
                const downloadUrl = window.URL.createObjectURL(response);
                const anchor = document.createElement('a');
                anchor.href = downloadUrl;
                anchor.download = translate('wearingPart.filename') + ".csv"
                anchor.click();
    
                // Clean up after download
                window.URL.revokeObjectURL(downloadUrl);
            },
            (error) => {
                console.error('Error downloading the file', error);
            }
        );
    }
    
    exportWearingPartsByRevision(id: string) {
        return this.http.get(`${environment.baseUrl}/v1/wearingParts/exportWearingPartsByRevision/${id}`, {
            responseType: 'blob' // Expecting a binary response (Blob)
        }).subscribe(
            (response: Blob) => {
                // Create a download link
                const downloadUrl = window.URL.createObjectURL(response);
                const anchor = document.createElement('a');
                anchor.href = downloadUrl;
                anchor.download = translate('wearingPart.filename') + ".csv"
                anchor.click();
    
                // Clean up after download
                window.URL.revokeObjectURL(downloadUrl);
            },
            (error) => {
                console.error('Error downloading the file', error);
            }
        );
    }
}